function escapeCell(v) {
  const s = v == null ? "" : String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * @param {string} filename
 * @param {{ key: string, header?: string }[]} columnDefs
 * @param {Record<string, unknown>[]} rows
 */
export function downloadCsv(filename, columnDefs, rows) {
  const header = columnDefs.map((c) => escapeCell(c.header || c.key)).join(",");
  const lines = rows.map((row) =>
    columnDefs.map((c) => escapeCell(row[c.key])).join(",")
  );
  const csv = [header, ...lines].join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
